module.exports = __webpack_public_path__ + "static/media/cloudy-day-3.109368f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/cloudy-day-3.svg
// module id = 512
// module chunks = 0